import { useState, useEffect } from "react";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { getCurrencyAmount } from "./../../../utils/stringUtils";

import Toaster from "./../../../components/common/Toaster";
import journalService from "../../../services/journalService";

const columns = [
  { label: "DATE" },
  { label: "NO." },
  { label: "NAME" },
  { label: "DESCRIPTION" },
  { label: "ACCOUNT" },
  { label: "DEBIT" },
  { label: "CREDIT" },
];

const GeneralJournal = ({ id }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        setIsLoading(true);

        const { result } =
          await journalService.getAccountGeneralJournalInfoAsync(id);

        const items = result.entries.map((item) => {
          item["debit_amount"] = item.debit && getCurrencyAmount(item.debit);
          item["credit_amount"] = item.credit && getCurrencyAmount(item.credit);

          return item;
        });

        result["entries"] = items;

        if (mounted) {
          setData(result);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    };

    fetchData(id);

    return () => {
      mounted = false;
    };
  }, [id]);

  const handleExport = async () => {
    try {
      const { result } = await journalService.generateGeneralJournalAsync(id);

      const mediaType =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";

      const link = document.createElement("a");
      link.href = mediaType + result.content;
      link.download = result.file_name;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  };

  return (
    <div className="card p-6">
      <div className="flex justify-end mb-2 px-5">
        <button
          className="button button-primary w-44 text-white"
          onClick={() => handleExport()}
        >
          <IoCloudDownloadOutline className="mr-2" /> Export to Excel
        </button>
      </div>
      {data && !isLoading && (
        <div className="p-4">
          <div className="mb-10 text-center">
            <p>Dr. {data.name}</p>
            <span className="font-bold text-sm">Journal</span>
          </div>
          <table className="min-w-full table-fixed">
            <thead>
              <tr className="border-t border-b border-black">
                {columns.map((item, index) => (
                  <th
                    key={index}
                    className="font-semibold text-sm py-1 px-4 text-left border-r border-gray-200 last:border-r-0"
                  >
                    {item.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.entries.length !== 0 &&
                data.entries.map((item, index) => {
                  return (
                    <tr key={index} className="text-sm">
                      <td className="px-4 py-2">{item.transaction_date}</td>
                      <td className="px-4 py-2">{item.transaction_number}</td>
                      <td className="px-4 py-2">{item.name}</td>
                      <td className="px-4 py-2">{item.description}</td>
                      <td className="px-4 py-2">{item.account}</td>
                      <td
                        className={`text-right px-4 py-2 ${
                          item.is_total && "font-black"
                        }`}
                      >
                        {item.debit_amount}
                      </td>
                      <td
                        className={`text-right px-4 py-2 ${
                          item.is_total && "font-black"
                        }`}
                      >
                        {item.credit_amount}
                      </td>
                    </tr>
                  );
                })}
              <tr className="border-t">
                <td className="uppercase font-semibold text-sm px-4 py-2">
                  Total
                </td>
                <td colSpan={5} className="text-right font-semibold text-sm">
                  PHP {getCurrencyAmount(data.total_debit)}
                </td>
                <td className="text-right font-semibold text-sm px-4 py-2">
                  PHP {getCurrencyAmount(data.total_credit)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default GeneralJournal;
